/* eslint-disable */
import React, {ReactNode} from "react";
import {makeStyles} from "@material-ui/core";
import {TooltipPlace, TooltipType, TooltipEffect} from "../../models/element";
import ReactTooltip from "react-tooltip";

interface TooltipStyleProps {
    // 表示位置
    place?: TooltipPlace;
    // タイプ
    type?: TooltipType;
    // 効果
    effect?: TooltipEffect;
    // 背景色
    backgroundColor?: string;
    // 枠
    border?: boolean;
    // 遅延表示
    delayShow?: number;
    delayUpdate?: number;
}

interface TooltipProps extends TooltipStyleProps {
    // 要素ID（利用側の「data-for」連携）
    id: string;
    // 内容
    children?: ReactNode;
    // 表示可否
    show?: boolean;
    // クリックイベント
    onClick?: () => void;
    // TODO: temp for homePage topImg
    text?: string;
}

const useStyles = makeStyles({
    arrow: {
        "&::before":{
            content:"none !important"
       },
        "&::after":{
            content:"none !important"
       },
        maxWidth:300,
        overflowWrap: "break-word"
   }
});

function PuiTooltip({id, children, show, onClick,text, ...props}: TooltipProps) {
    const {
        place = "bottom",
        type = "light",
        effect = "solid",
        backgroundColor = "white",
        border = true,
        delayShow = 1000,
        delayUpdate = 100
   } = props;
    const classes = useStyles();

    return (
        <ReactTooltip
            id={id}
            place={place}
            type={type}
            effect={effect}
            delayShow={delayShow}
            delayUpdate={delayUpdate}
            multiline={true}
            border={border}
            backgroundColor={backgroundColor}
            getContent={(dataTip) => (text) ? (<div>{text}</div>):(<div>{dataTip}</div>)}
            overridePosition={(
                {left, top}
            ) => {
                left = left + 90;
                top = top - 20;
                return {top, left};
           }}
            className={classes.arrow}
        />
    );
}

export default PuiTooltip;
